import { render, staticRenderFns } from "./ModalAssignCompaniesToCollaborators.vue?vue&type=template&id=493f0cd7&scoped=true"
import script from "./ModalAssignCompaniesToCollaborators.vue?vue&type=script&lang=js"
export * from "./ModalAssignCompaniesToCollaborators.vue?vue&type=script&lang=js"
import style0 from "./ModalAssignCompaniesToCollaborators.vue?vue&type=style&index=0&id=493f0cd7&prod&scoped=true&lang=css"
import style1 from "./ModalAssignCompaniesToCollaborators.vue?vue&type=style&index=1&id=493f0cd7&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493f0cd7",
  null
  
)

export default component.exports